let context = '/MazeMallCreative';

let externhost = 'h5.yeapar.com';

let wsPort = ":8080";

let useLocalResource = false; // 是否使用本地资源

export function setContext(ctx) {
    context = ctx;
}

export function getContext() {
    return context;
}

export function setExternhost(host) {
    externhost = host;
}

export function getExternhost() {
    return externhost;
}

export function setWsPort(port) {
    wsPort = port;
}

export function getWsPort() {
    return wsPort;
}

export function setUseLocalResource(yesorno) {
    useLocalResource = yesorno;
}

export function getUseLocalResource() {
    return useLocalResource;
}

export function setAllConf(res) {
    if (res.externhost)
        externhost = res.externhost;
    if (res.context)
        context = res.context;
    if (res.wsPort)
        wsPort = res.wsPort;
    if (res.useLocalResource)
        useLocalResource = res.useLocalResource;
}